var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ed"}},[_c('el-tiptap',{attrs:{"extensions":_vm.extensions,"placeholder":"Write something ..."},on:{"onUpdate":_vm.updatedContent},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }